export const PLATFORM_STATUS_URL = 'https://status.mews.com';
export const MEWS_WEBSITE_URL = 'https://www.mews.com';
export const MEWS_FACEBOOK_URL = 'https://facebook.com/MewsSystems';
export const MEWS_TWITTER_URL = 'https://twitter.com/MewsSystems';
export const MEWS_LINKEDIN_URL = 'https://www.linkedin.com/company/mewssystems';
export const MEWS_CONTACT_US_URL = `${MEWS_WEBSITE_URL}/en/contact-us`;
export const MEWS_HELP = 'https://help.mews.com';
export const MEWS_HELP_ARTICLE_PATH = `${MEWS_HELP}/s/article`;
